<template>
  <div class="faq-banner">
    <BaseBreadcrumb
      v-if="getBreadcrumb"
      class="container"
      :breadcrumb="getBreadcrumb"
    />
    <div class="faq-banner__container">
      <div>
        <img
          data-src="@images/public/faq/faq.svg"
          class="lazyload mt-4 lg:mt-[100px] w-[64px] h-[70px] lg:w-[116px] lg:h-[127px]"
          alt="faq-banner"
        >
        <p class="faq-banner__title">
          Frequently asked questions
        </p>
      </div>
      <div class="mt-1 lg:mt-0">
        <picture>
          <source :srcset="desktopImage" media="(min-width: 1024px)">
          <img
            :data-src="mobileImage"
            class="lazyload"
            alt="faq-banner"
          >
        </picture>
      </div>
    </div>
  </div>
</template>

<script>
import BaseBreadcrumb from '@design-system/base/breadcrumb/breadcrumb-pages'
import { mapGetters } from 'vuex'

export default {
  name: 'FaqBanner',
  components: { BaseBreadcrumb },
  computed: {
    ...mapGetters('global', ['getBreadcrumb']),
    desktopImage () {
      return require('@images/public/faq/main.png')
    },
    mobileImage () {
      return require('@images/public/faq/main-sm.png')
    }
  }
}
</script>

<style scoped lang="scss">
.faq-banner {
  @apply bg-primary-50 w-full rounded-br-[40px] pt-4;
  &__container {
    @apply container flex flex-col lg:flex-row justify-between  relative lg:-mt-[22px];
  }
  &__title {
    @apply absolute top-[12%] lg:top-[50%] left-[12%] lg:left-0 text__headline-3-xs--bold lg:text__headline-3-md--bold text-primary-700;
  }
}
</style>
